export default __webpack_public_path__ + "static/media/essentialSeoHero.0508ea9d.jpg";